module.exports = __webpack_public_path__ + "static/img/vamp_logo.a253f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vamp_logo.png
// module id = uHdc
// module chunks = 1